import { motion } from "framer-motion";
import { MapPin } from "lucide-react";

const DEPARTMENTS = [
  { name: "Seine-Maritime", code: "76", cities: "Rouen, Le Havre, Dieppe, Fécamp, Yvetot" },
  { name: "Eure", code: "27", cities: "Évreux, Bernay, Pont-Audemer, Bourg-Achard" },
  { name: "Calvados", code: "14", cities: "Caen, Lisieux, Bayeux, Honfleur, Deauville" },
];

export default function Zone() {
  return (
    <section id="zone" data-testid="zone-section" className="relative py-28 lg:py-40 border-t border-white/10 overflow-hidden">
      <div className="absolute inset-0 opacity-20">
        <img
          src="https://images.unsplash.com/photo-1632313808864-0799c058cf4f?q=80&w=2000&auto=format&fit=crop"
          alt="Mont-Saint-Michel, Normandie"
          loading="lazy"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#09090B] via-[#09090B]/70 to-[#09090B]" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-2 gap-16">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="lg:sticky lg:top-32 self-start"
        >
          <p className="text-xs tracking-[0.3em] uppercase text-jaune font-bold mb-4">Zone d'intervention</p>
          <h2 className="font-display font-bold uppercase tracking-tight text-3xl sm:text-4xl md:text-5xl leading-tight">
            Toute la Normandie, notre terrain
          </h2>
          <p className="mt-6 text-base text-zinc-400 leading-relaxed font-light max-w-md">
            Basés à Bosgouet, au cœur de la Normandie, nous intervenons en Seine-Maritime,
            dans l'Eure et le Calvados pour vos projets neufs comme vos rénovations.
            Déplacement et étude de votre toiture gratuits.
          </p>
        </motion.div>

        <div data-testid="zone-departments-list">
          {DEPARTMENTS.map((d, i) => (
            <motion.div
              key={d.code}
              initial={{ opacity: 0, x: 40 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="group flex items-center justify-between gap-6 py-7 border-b border-white/10 hover:border-jaune/50 transition-colors duration-300"
              data-testid={`zone-department-${d.code}`}
            >
              <div className="flex items-center gap-5">
                <span className="font-display font-black text-2xl text-outline group-hover:text-jaune group-hover:[-webkit-text-stroke:0px] transition-all duration-300">
                  {d.code}
                </span>
                <div>
                  <h3 className="font-display font-bold uppercase tracking-tight text-xl">{d.name}</h3>
                  <p className="text-xs text-zinc-500 mt-1">{d.cities}</p>
                </div>
              </div>
              <MapPin className="w-5 h-5 text-zinc-600 group-hover:text-jaune transition-colors duration-300 shrink-0" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
